import { render } from "./errorLogin.vue?vue&type=template&id=319abaf8&scoped=true"
import script from "./errorLogin.vue?vue&type=script&lang=js"
export * from "./errorLogin.vue?vue&type=script&lang=js"

import "./errorLogin.vue?vue&type=style&index=0&id=319abaf8&scoped=true&lang=css"

import exportComponent from "D:\\myWorkspace\\CoreServiceAzure\\CoreServiceCloud\\MyNews\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-319abaf8"]])

export default __exports__